/* ============================================================
   DBYZ — Custom JavaScript  (FIXED v2)
   PATH: assets/dbyz-custom.js
   HOW TO LOAD: In layout/theme.liquid, just before </body>:
   <script src="{{ 'dbyz-custom.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var dot, ring;

  // ── Custom Cursor ─────────────────────────────────────────────
  function initCursor() {
    dot  = document.getElementById('dbyz-cursor-dot');
    ring = document.getElementById('dbyz-cursor-ring');

    // Create elements if the snippet wasn't rendered
    if (!dot) {
      dot = document.createElement('div');
      dot.id = 'dbyz-cursor-dot';
      document.body.insertBefore(dot, document.body.firstChild);
    }
    if (!ring) {
      ring = document.createElement('div');
      ring.id = 'dbyz-cursor-ring';
      document.body.insertBefore(ring, document.body.firstChild);
    }

    // Force hide native cursor on everything
    document.body.style.cursor = 'none';
    var styleTag = document.createElement('style');
    styleTag.textContent = '*, *::before, *::after { cursor: none !important; }';
    document.head.appendChild(styleTag);

    var mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    // Ring follows with physics lag
    (function loop() {
      rx += (mx - rx) * 0.1;
      ry += (my - ry) * 0.1;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(loop);
    })();

    // Grow cursor on interactive elements
    document.addEventListener('mouseover', function (e) {
      var isInteractive = !!e.target.closest('a, button, .dbyz-sz, .dbyz-pc, .dbyz-nav__bag, .dbyz-lc');
      document.body.classList.toggle('dbyz-cur-big', isInteractive);
    });

    // Hide when mouse leaves window, show on re-entry
    document.addEventListener('mouseleave', function () {
      dot.style.opacity = '0'; ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function () {
      dot.style.opacity = '1'; ring.style.opacity = '1';
    });
  }

  // ── Grain overlay ─────────────────────────────────────────────
  function initGrain() {
    var grain = document.getElementById('dbyz-grain');
    if (!grain) {
      grain = document.createElement('div');
      grain.id = 'dbyz-grain';
      document.body.appendChild(grain);
    }
  }

  // ── Scroll Reveal ─────────────────────────────────────────────
  function initReveal() {
    if (!window.IntersectionObserver) {
      document.querySelectorAll('.dbyz-reveal').forEach(function (el) { el.classList.add('dbyz-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dbyz-on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.dbyz-reveal').forEach(function (el) { io.observe(el); });
  }

  // ── Dark section detection ────────────────────────────────────
  function initDarkDetect() {
    var darkEls = document.querySelectorAll('.dbyz-ticker, .dbyz-drop, .dbyz-manifesto, .dbyz-campaign, footer, .footer');
    if (!darkEls.length) return;
    function check() {
      var anyDark = false;
      darkEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.4) anyDark = true;
      });
      document.body.classList.toggle('dbyz-on-dark', anyDark);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // ── Lifestyle drag scroll ─────────────────────────────────────
  function initDragScroll() {
    var track = document.getElementById('dbyz-life-track');
    if (!track) return;
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true; startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft; track.style.cursor = 'grabbing';
    });
    track.addEventListener('mouseleave', function () { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mouseup',    function () { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mousemove',  function (e) {
      if (!isDown) return; e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.5;
    });
    var ts, tsl;
    track.addEventListener('touchstart', function (e) { ts = e.touches[0].pageX; tsl = track.scrollLeft; }, { passive: true });
    track.addEventListener('touchmove',  function (e) { track.scrollLeft = tsl - (e.touches[0].pageX - ts); }, { passive: true });
  }

  // ── Boot ──────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(pointer: fine)').matches) initCursor();
    initGrain();
    initReveal();
    initDarkDetect();
    initDragScroll();
  });

})();
